(function () {
    'use strict';

    angular.module('elogbooks.user.contact-us').config(registerRoutes);

    function registerRoutes($stateProvider) {
        $stateProvider
            .state('dashboard.user.contact-us', {
                abstract: true,
                template: '<bookerize></bookerize>',
                ncyBreadcrumb: {
                    skip: true
                }
            })
            .state('dashboard.user.contact-us.details', {
                url: '/contact-us',
                parent: 'dashboard.user.contact-us',
                views: {
                    '@dashboard.user.contact-us': {
                        templateUrl: '/modules/user/contact-us/contact-us.html',
                        controller: 'UserContactUsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    hasServiceDesk: function (apiClient, rootResourceResponse) {
                        return apiClient.get(rootResourceResponse.getLink('client_has_service_desk')).then(function (response) {
                            return response || apiClient.noResourceFound();
                        });
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"CONTACT_US" | translate }}'
                }
            }
        );
    }
})();
